const WorktimeTypeEnum = {
    RW: 'Regular work',
    ED: 'Education',
    OV: 'Overtime',
    POV: 'Passive overtime',
  };

export default WorktimeTypeEnum;